module.exports = __webpack_public_path__ + "img/arrow.073c322b.png";